import styled from "styled-components";


export const InputContainer = styled.div<{color: string}>`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  border: 1px solid ${({ color }) => color};
  padding: 0 1rem;
  gap: 0.5rem;
  margin: 0.75rem 0;

  svg {
    color: ${({color}) => color};
  }

  input {
    flex: 1;
    background: transparent;
    border: 0;
    outline: 0;
    color: ${({ theme }) => theme.colors.gray900.main};
    line-height: 2;
    height: 35px;

    &:focus {
      outline: 0;
    }

    &::placeholder {
      color:${({ theme }) => theme.colors.gray900.main};
      font-size: 0.9rem;
    }
  }

  .suffix-span {
    ${({ color }) => color};
  }
`;

export const Input = styled.input`
  border: none;
  height: 100%;
  width: 100%;

  &:focus {
    outline: none;
  }
`;
